import React, { FC, SyntheticEvent } from "react";
import { COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { StyledTab, StyledTabs } from "./styled";
import { getTabProps, InquiriesAndDataAnalyticsTabs } from "./utils";

type TabsProps = {
  selectedTab: InquiriesAndDataAnalyticsTabs;
  setSelectedTab: (arg0: InquiriesAndDataAnalyticsTabs) => void;
};
const Tabs: FC<TabsProps> = ({ selectedTab, setSelectedTab }) => {
  const handleTabChange = (
    _: SyntheticEvent,
    newTab: InquiriesAndDataAnalyticsTabs,
  ) => {
    setSelectedTab(newTab);
  };

  return (
    <StyledTabs
      value={selectedTab}
      onChange={handleTabChange}
      TabIndicatorProps={{
        style: {
          backgroundColor: COLOR_PRIMARY_MAIN,
          height: 2,
        },
      }}
    >
      <StyledTab
        {...getTabProps(InquiriesAndDataAnalyticsTabs.Inquiries)}
        value={InquiriesAndDataAnalyticsTabs.Inquiries}
        disableRipple
        label="1:1 Inquiries"
      />
      <StyledTab
        {...getTabProps(InquiriesAndDataAnalyticsTabs.DataAnalytics)}
        value={InquiriesAndDataAnalyticsTabs.DataAnalytics}
        disableRipple
        label="Data Analytics"
      />
    </StyledTabs>
  );
};

export default Tabs;
